import { can } from "./permissions.ts";

export type ReviewAccess = "ALLOWED" | "NOT_REVIEWER" | "NOT_OWNER_OR_ADMIN" | "OWN_REVISION";

/**
 * Who may record a review decision on a version.
 *
 * A project tied to a task is decided by the task's owner or the trip admin, and nobody
 * approves a version they uploaded. A project with no task keeps the original rule: anyone
 * holding `revision.review` or `trip.manage`, including the version's own uploader.
 */
export function reviewAccess(input: {
  roles: readonly string[];
  userId: string;
  taskOwnerId: string | null;
  revisionAuthorId: string;
  decision: "APPROVE" | "REQUEST_CHANGES";
}): ReviewAccess {
  const admin = can(input.roles, "trip.manage");
  if (input.taskOwnerId === null) {
    return admin || can(input.roles, "revision.review") ? "ALLOWED" : "NOT_REVIEWER";
  }
  if (!admin && input.userId !== input.taskOwnerId) return "NOT_OWNER_OR_ADMIN";
  if (input.decision === "APPROVE" && input.revisionAuthorId === input.userId)
    return "OWN_REVISION";
  return "ALLOWED";
}
